(function () {
  'use strict';

  window.PGCompleteSetSettings = Object.assign({
    discountRate: 0.20,
    discountActive: true,
    discountCode: 'PGCOMPLETE20'
  }, window.PGCompleteSetSettings || {});

  function mug(targetProductId, targetHandle, options) {
    return Object.assign({
      type: 'mug',
      title: 'Matching mug',
      buttonLabel: 'Add mug',
      selectorLabel: 'Choose an option',
      targetProductId: targetProductId,
      targetHandle: targetHandle
    }, options || {});
  }

  function cushion(targetProductId, targetHandle, options) {
    return Object.assign({
      type: 'cushion',
      title: 'Matching cushion',
      buttonLabel: 'Add cushion',
      selectorLabel: 'Choose size',
      targetProductId: targetProductId,
      targetHandle: targetHandle
    }, options || {});
  }

  function phoneCase(targetProductId, targetHandle, options) {
    return Object.assign({
      type: 'phone_case',
      title: 'Matching phone case',
      buttonLabel: 'Add phone case',
      selectorLabel: 'Choose phone model',
      targetProductId: targetProductId,
      targetHandle: targetHandle
    }, options || {});
  }

  function digitalDownload(options) {
    return Object.assign({
      type: 'digital_download',
      title: 'Digital copy',
      buttonLabel: 'Add digital copy',
      targetProductId: 5736798978202,
      targetHandle: 'digital-image-download'
    }, options || {});
  }

  var config = {};

  function register(sourceIds, family, offers, sourceOptions) {
    sourceIds.forEach(function (sourceId) {
      var sourceKey = String(sourceId);
      config[sourceKey] = Object.assign({
        sourceProductId: Number(sourceId),
        family: family,
        offers: offers.concat([digitalDownload({ fixedVariantId: 40269968638145 })]).map(function (offer) { return Object.assign({}, offer); })
      }, sourceOptions && sourceOptions[sourceKey] || {});
    });
  }

  register(
    [6119401783489, 5647930556570],
    'the-general',
    [
      mug(5647927804058, 'the-general-custom-pet-mug', { fixedVariantId: 35849139093658 }),
      cushion(6733077872833, 'the-general-custom-pet-pillow'),
      phoneCase(6816778387649, 'the-general-custom-pet-phone-case')
    ]
  );

  register(
    [6624553500865, 6740821311681],
    'the-duke',
    [
      mug(5520141942938, 'the-duke-custom-pet-mug'),
      cushion(6732873564353, 'the-duke-custom-pet-pillow'),
      phoneCase(6814736384193, 'the-duke-custom-pet-phone-case')
    ]
  );

  register(
    [6077473489089, 6814688411841],
    'minimalist',
    [
      mug(6077397303489, 'minimalist-custom-pet-mug', { fixedVariantId: 40447703974081 }),
      cushion(6077397434561, 'minimalist-custom-pet-pillow', { petCount: '1' }),
      phoneCase(6816367968449, 'minimalist-custom-pet-phone-case', { petCount: '1' })
    ],
    {
      '6077473489089': {
        eligibleSourceVariantIds: [
          42273548599548, 40059182547137, 40059182612673,
          42273548632316, 37522750898369, 37522750963905,
          42273548697852, 37522750603457, 37522750668993,
          42273548730620, 37522750701761, 37522750767297,
          42273548763388, 42561342406908, 42561344274684
        ]
      }
    }
  );

  register(
    [6119534133441, 5520520741018],
    'the-colonel',
    [
      mug(5520688906394, 'the-colonel-custom-pet-mug'),
      cushion(6732876939457, 'the-colonel-custom-pet-pillow'),
      phoneCase(6826111402177, 'the-colonel-custom-pet-phone-case')
    ]
  );

  register(
    [6787438772417, 6787437527233],
    'the-pearl-princess',
    [
      mug(6787436249281, 'the-pearl-princess-custom-pet-mug'),
      cushion(6787436609729, 'the-pearl-princess-custom-pet-pillow'),
      phoneCase(6889637806273, 'the-pearl-princess-custom-pet-phone-case')
    ]
  );

  register(
    [6586790314177],
    'his-highness',
    [
      mug(6586786939073, 'his-highness-custom-pet-mug'),
      cushion(6586785366209, 'his-highness-custom-pet-pillow'),
      phoneCase(6830517223617, 'his-highness-custom-pet-phone-case')
    ]
  );

  register(
    [6807297458369, 6807296508097],
    'the-first-lieutenant',
    [
      mug(6807295393985, 'the-first-lieutenant-custom-pet-mug'),
      cushion(6807295721665, 'the-first-lieutenant-custom-pet-pillow'),
      phoneCase(6825641705665, 'the-first-lieutenant-custom-pet-phone-case')
    ]
  );

  register(
    [6732883722433],
    'the-veteran',
    [
      mug(5629168418970, 'the-veteran-custom-pet-mug'),
      cushion(6732885229761, 'the-veteran-custom-pet-pillow'),
      phoneCase(6816894779585, 'the-veteran-custom-pet-phone-case')
    ]
  );

  register(
    [7506514673916, 7506513330428],
    'the-thug',
    [
      mug(7506512576764, 'the-thug-peaky-blinders-inspired-custom-pet-mug'),
      cushion(7506512871676, 'the-thug-peaky-blinders-inspired-custom-pet-pillow'),
      phoneCase(7506514739452, 'the-thug-peaky-blinders-inspired-custom-pet-snap-phone-case')
    ]
  );

  register(
    [6902628057281],
    'the-princesses',
    [
      mug(6811159199937, 'the-princesses-custom-pet-mug'),
      cushion(6811158380737, 'the-princesses-custom-pet-pillow'),
      phoneCase(6881231077569, 'the-princesses-custom-pet-phone-case')
    ]
  );

  register(
    [6789888671937],
    'the-spanish-princess',
    [
      mug(6789886378177, 'the-spanish-princess-custom-pet-mug'),
      cushion(6789886640321, 'the-spanish-princess-custom-pet-pillow'),
      phoneCase(6826062774465, 'the-spanish-princess-custom-pet-phone-case')
    ]
  );

  register(
    [5633945829530],
    'the-princess',
    [
      mug(5633937637530, 'the-princess-custom-pet-mug'),
      cushion(6732949061825, 'the-princess-custom-pet-pillow'),
      phoneCase(6827175051457, 'the-princess-custom-pet-phone-case')
    ]
  );

  register(
    [6803032637633],
    'the-count',
    [
      mug(6803031130305, 'the-count-custom-pet-mug'),
      cushion(6803031064769, 'the-count-custom-pet-pillow'),
      phoneCase(6813643768001, 'the-count-custom-pet-phone-case')
    ]
  );

  register(
    [6104917770433],
    'the-1920s-og',
    [
      mug(5731869917338, 'tommy-peaky-blinders-inspired-custom-pet-mug'),
      cushion(6733341130945, 'tommy-peaky-blinders-inspired-custom-pet-pillow'),
      phoneCase(7002141327553, 'tommy-peaky-blinders-inspired-custom-pet-phone-case')
    ]
  );

  register(
    [5629611999386, 6732935823553],
    'the-baroness',
    [
      mug(5629610590362, 'the-archduchess-custom-pet-mug'),
      cushion(6732938805441, 'the-archduchess-custom-pet-cushion'),
      phoneCase(6816888553665, 'the-baroness-custom-pet-phone-case')
    ]
  );

  register(
    [6808119476417],
    'the-rulers',
    [
      mug(6808117838017, 'the-rulers-custom-pet-mug'),
      cushion(6808117739713, 'the-rulers-custom-pet-pillow')
    ]
  );

  register(
    [7453360947452],
    'the-betrothed',
    [
      mug(7447119036668, 'the-betrothed-custom-pet-mug'),
      cushion(7447119888636, 'the-betrothed-custom-pet-cushion'),
      phoneCase(7453361242364, 'the-betrothed-custom-pet-snap-phone-case')
    ]
  );

  register(
    [6733319012545],
    'step-doggos',
    [
      mug(5654946447514, 'step-doggos-custom-pet-mug'),
      cushion(6733322322113, 'step-doggos-custom-pet-cushion'),
      phoneCase(6816541966529, 'step-doggos-custom-pet-phone-case')
    ]
  );

  register(
    [6801045717185],
    'delboy',
    [
      mug(6801044373697, 'delboy-only-fools-horses-inspired-custom-pet-mug'),
      cushion(6801044635841, 'delboy-only-fools-horses-inspired-custom-pet-cushion'),
      phoneCase(6813649797313, 'delboy-only-fools-horses-inspired-custom-pet-phone-case')
    ]
  );

  register(
    [6833514610881],
    'harley-wooferson',
    [
      mug(6545257889985, 'harley-wooferson-custom-pet-mug'),
      cushion(6788376985793, 'harley-wooferson-custom-pet-pillow'),
      phoneCase(6830512701633, 'harley-wooferson-custom-pet-phone-case')
    ]
  );

  register(
    [7476653162748],
    '1920s-gangster-couple',
    [
      mug(7476652114172, 'peaky-blinders-male-female-mug'),
      cushion(7476652310780, 'peaky-blinders-male-female-custom-pet-cushion'),
      phoneCase(8020069449980, 'peaky-blinders-male-female-snap-phone-case')
    ]
  );

  register(
    [7709779165436],
    'custom-cartoon',
    [
      mug(7709775364348, 'custom-popart-pet-coffee-mug'),
      cushion(7709777035516, 'custom-cartoon-pet-portrait-pillow')
    ]
  );

  register(
    [8021855174908],
    'dogue',
    [mug(8024444141820, 'dogue-custom-pet-coffee-mug')]
  );

  register(
    [6852612784321],
    'the-golden-king',
    [
      mug(6852611670209, 'the-golden-king-custom-pet-mug'),
      cushion(6852611932353, 'the-golden-king-custom-pet-pillow'),
      phoneCase(6852612456641, 'the-golden-king-custom-pet-phone-case')
    ]
  );

  register(
    [7646684643580],
    'bad-boys',
    [
      mug(7646657085692, 'bad-boys-custom-pet-mug'),
      cushion(7646676320508, 'bad-boys-custom-pet-pillow'),
      phoneCase(7646687985916, 'bad-boys-custom-pet-snap-phone-case')
    ]
  );

  register(
    [7838493671676],
    'floral-crown-modern',
    [mug(7907943547132, 'floral-crown-modern-pet-coffee-mug')]
  );

  register(
    [7922286526716],
    'england-football-team',
    [
      mug(7922284593404, 'england-football-team-fifa-2022-custom-pet-mug'),
      cushion(7922284953852, 'england-football-team-fifa-2022-custom-pet-pillow'),
      phoneCase(7922286199036, 'england-football-team-fifa-2022-custom-pet-phone-case')
    ]
  );

  window.PGCompleteSetConfig = config;
  window.PGCompleteSetRollout = {
    version: 'v19',
    collectionId: 471590437116,
    collectionHandle: 'best-sellers-2026',
    configuredSourceProductIds: Object.keys(config),
    excludedSourceProductIds: ['9378576367868'],
    excludedReason: 'No verified matching add-on products exist for World Cup 2026 yet.'
  };
})();
